import './Theme10.css';

import * as cuponeraActions from '../../cuponera/redux/actions';

import { HomeBanners, ThemeTenSearchBox } from '..';
import React, { useEffect, useState } from 'react';

import CommonSearchBox from '../common/search-box/CommonSearchBox.js';
import ContactForm4 from '../common/contact/ContactForm4';
import MultiSlider3 from '../common/MultiSlider/MultiSlider3';
import ThemeFiveIconsSection from '../theme5/components/ThemeFiveIconsSection.js';
import { ThemeTenTitle } from './components/ThemeTenTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';
import socialMedia1 from '../assets/andimar/social-media/fb.png';
import socialMedia2 from '../assets/andimar/social-media/insta.png';

function Theme10({ history, operator, actions }) {
	useEffect(() => {
		// Clean up cuponera session storage data
		sessionStorage.removeItem('cuponeraSourceCity');
		sessionStorage.removeItem('cuponeraDestinationCity');
		sessionStorage.removeItem('cuponeraSeats');
		sessionStorage.removeItem('selectedCuponera');
		actions.setCuponeraSeats({});
		actions.setSelectCuponera(null);
	}, []);

	const opname = operator && operator.operator_name;
	const takeCareIcons = [
		{
			text: (
				<span>
					<strong> Control satelital </strong>
					para conocer <br />
					la ubicación en tiempo real.
				</span>
			),
			image: getIcons('ammenity1', operator),
		},
		{
			text: (
				<span>
					Entrega de
					<strong> snacks </strong>
					<br />
					durante el viaje.
				</span>
			),
			image: getIcons('ammenity2', operator),
		},
		{
			text: (
				<span>
					Cinturón de seguridad
					<br /> de tres <strong> puntas.</strong>
				</span>
			),
			image: getIcons('ammenity3', operator),
		},
		{
			text: (
				<span>
					<strong> Entretención </strong> a bordo <br />
					para los pasajeros.
				</span>
			),
			image: getIcons('ammenity4', operator),
		},
	];

	const takeCareIconsTraveltur = [
		{
			text: (
				<span>
					<strong> Servicios de transporte</strong>
					<br />a la minería
				</span>
			),
			image: getIcons('ammenity1', operator),
			link: '/travel-norte',
		},
		{
			text: (
				<span>
					Buses de
					<strong>
						{' '}
						última <br /> generación{' '}
					</strong>
				</span>
			),
			image: getIcons('ammenity2', operator),
			link: '/about-us',
		},
		{
			text: (
				<span>
					<strong> Contratos y convenios</strong>
					<br />
					<span>especiales</span>
				</span>
			),
			image: getIcons('ammenity3', operator),
			link: '/servicios-especiales',
		},
	];

	const contactByArr = [
		{
			text: `${operator && operator.phone_number}`,
			image: getIcons('Support'),
		},
		{
			text: `${operator && operator.email}`,
			image: getIcons('ContactEmail'),
		},
		{
			text: `${operator && operator.address}`,
			image: getIcons('ContactLocation'),
		},
	];

	const getLinks = () => {
		if (opname === 'sanantonio') {
			return {
				fb: 'https://www.facebook.com/busessantonio',
				insta: 'https://www.instagram.com/busessanantonio',
			};
		}

		if (opname === 'tacoha') {
			return {
				fb:
					'https://m.facebook.com/profile.php?id=312792345524109&eav=AfYgkHnJP0-n0YtyfVSxGXGDoh6o9sahtN65X43pwDTqwo51-XWG1sJNkVDjGU9t9bY&paipv=0',
				insta: 'https://www.instagram.com/tacohacl/',
			};
		}
		return {
			fb: '',
			insta: '',
		};
	};

	const socialMedia = [
		{
			id: 0,
			selectedIcon: getIcons('FbInActive', operator),
			icon1: getIcons('FbInActive', operator),
			icon2: getIcons('FbActive', operator),
			link: getLinks().fb,
		},
		{
			id: 1,
			selectedIcon: getIcons('InstaInActive', operator),
			icon1: getIcons('InstaInActive', operator),
			icon2: getIcons('InstaActive', operator),
			link: getLinks().insta,
		},
	];
	const [showPopup, setShowPopup] = useState(true);
	const [socialMediaArray, setSocialMediaArray] = useState(socialMedia);

	const operator_name = operator && operator.operator_name;

	const onMouseStateChange = (method, item) => {
		let socialMediaNew = [];

		socialMediaArray.map((val, key) => {
			if (val.id === item.id) {
				socialMediaNew.push({
					...val,
					selectedIcon: method === 'in' ? val.icon2 : val.icon1,
				});
			} else {
				socialMediaNew.push({
					...val,
					selectedIcon: val.icon1,
				});
			}
		});
		setSocialMediaArray(socialMediaNew);
	};

	const renderTakeCareIcons = icons => {
		return (
			<div>
				<div className="light-grey-background"></div>
				<div className="take-care d-flex " style={{ justifyContent: 'space-around' }}>
					{icons.map(item => (
						<div
							className="take-care-item d-flex flex-column align-items-center text-center"
							style={{ width: '25%' }}
						>  <a a href={item.link}>
								<img src={item.image} alt="" />
							</a>
							<p className="mt-2">{item.text}</p>
						</div>
					))}
				</div>
			</div>
		);
	};

	const renderTravelturOrderSections = () => {
		return (
			<div className="new-container">
				{operator_name === 'tacoha' ? null : (
					<div>
						<div style={{ marginTop: 80 }}>
							<ThemeTenTitle
								title={
									operator_name === 'liquine'
										? '¡También te ofrecemos!'
										: operator_name === 'traveltur'
											? 'TE OFRECEMOS'
											: 'SERVICIOS A BORDO'
								}
							/>
						</div>

						{operator_name === 'liquine' ? (
							<div style={{ marginBottom: 50 }}>
								<ThemeFiveIconsSection />
							</div>
						) : (
							renderTakeCareIcons(
								operator_name === 'traveltur' ? takeCareIconsTraveltur : takeCareIcons,
							)
						)}
					</div>
				)}
				<div style={{ marginTop: 50 }}>
					<ThemeTenTitle
						title={
							operator_name === 'traveltur' ? 'DESTINOS FAVORITOS' : 'NUESTROS DESTINOS FAVORITOS'
						}
					/>
				</div>

				<div>
					<MultiSlider3
						multiSlides={getSlides('Destination', operator)}
						removeArrowOnDeviceType={[]}
						operator={operator}
					/>
				</div>

				{operator_name === 'liquine' || operator_name === 'traveltur' ? null : (
					<div className="contact-us d-flex my-5 ">
						<ContactForm4 operator={operator} isSanantonio dashLine />
						<div className="contact-by w-50 d-flex justify-center align-items-start flex-column ">
							{contactByArr.map(item => (
								<div className="contact-by-item d-flex ">
									<img src={item.image} alt="" style={{ width: '40px' }} />
									<span
										className="lh-1-3"
										style={{ fontWeight: 'bold', fontSize: '13px', width: '194px' }}
									>
										{item.text}
									</span>
								</div>
							))}
							<div className="social-media">
								<div
									style={{
										color: operator.sub_footer_color && operator.sub_footer_color,
										marginBottom: 10,
										fontWeight: 'bold',
										fontSize: '16px',
									}}
								>
									SÍGUENOS EN REDES SOCIALES
								</div>
								<div>
									{socialMediaArray.map(item => (
										<a
											href={item.link}
											target="_blank"
											onMouseEnter={() => onMouseStateChange('in', item)}
											onMouseLeave={() => onMouseStateChange('out', item)}
										>
											<img src={item.selectedIcon} alt="" />
										</a>
									))}
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	};

	const renderNonTravelturOrderSections = () => {
		return (
			<div className="new-container">
				<div style={{ marginTop: 80 }}>
					<ThemeTenTitle
						title={
							operator_name === 'traveltur' ? 'DESTINOS FAVORITOS' : 'NUESTROS DESTINOS FAVORITOS'
						}
					/>
				</div>

				<div>
					<MultiSlider3
						multiSlides={getSlides('Destination', operator)}
						removeArrowOnDeviceType={[]}
						operator={operator}
					/>
				</div>

				{operator_name === 'tacoha' ? null : (
					<div>
						<div style={{ marginTop: 50 }}>
							<ThemeTenTitle
								title={
									operator_name === 'liquine'
										? '¡También te ofrecemos!'
										: operator_name === 'traveltur'
											? 'TE OFRECEMOS'
											: 'SERVICIOS A BORDO'
								}
							/>
						</div>

						{operator_name === 'liquine' ? (
							<div style={{ marginBottom: 50 }}>
								<ThemeFiveIconsSection />
							</div>
						) : (
							renderTakeCareIcons(
								operator_name === 'traveltur' ? takeCareIconsTraveltur : takeCareIcons,
							)
						)}
					</div>
				)}

				{operator_name === 'liquine' || operator_name === 'traveltur' ? null : (
					<div className="contact-us d-flex my-5 ">
						<ContactForm4 operator={operator} isSanantonio dashLine />
						<div className="contact-by w-50 d-flex justify-center align-items-start flex-column ">
							{contactByArr.map(item => (
								<div className="contact-by-item d-flex ">
									<img src={item.image} alt="" style={{ width: '40px' }} />
									<span
										className="lh-1-3"
										style={{ fontWeight: 'bold', fontSize: '13px', width: '194px' }}
									>
										{item.text}
									</span>
								</div>
							))}
							<div className="social-media">
								<div
									style={{
										color: operator.sub_footer_color && operator.sub_footer_color,
										marginBottom: 10,
										fontWeight: 'bold',
										fontSize: '16px',
									}}
								>
									SÍGUENOS EN REDES SOCIALES
								</div>
								<div>
									{socialMediaArray.map(item => (
										<a
											href={item.link}
											target="_blank"
											onMouseEnter={() => onMouseStateChange('in', item)}
											onMouseLeave={() => onMouseStateChange('out', item)}
										>
											<img src={item.selectedIcon} alt="" />
										</a>
									))}
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	};

	return (
		<div style={{ overflowX: 'hidden' }} className="theme-ten montserrat">
			<div style={{ position: 'relative' }}>
				<HomeBanners
					slides={getSlides('Banner', operator)}
					height={'98vh'}
					activeDotColor={operator && operator.color_codes && operator.color_codes.button_color}
				/>

				<div className="searchBoxOverlay">
					<div className="new-container">
						<CommonSearchBox history={history} operator={operator} />
						{/* <ThemeTenSearchBox history={history} operator={operator} /> */}
					</div>
				</div>
			</div>
			{operator_name === 'traveltur'
				? renderTravelturOrderSections()
				: renderNonTravelturOrderSections()}
		</div>
	);
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...cuponeraActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Theme10);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/Theme10.js